import React, {Component} from 'react';
import Header from "./header";
import "./homePage.css";
import Slider from "react-slick";
import Footer from "./footer";
import Articles from "../articles/articles";
import { Responsive, Container, Grid, Image } from 'semantic-ui-react';
import HistoryItem from "./historyitem";
import FacebookProvider, { Page } from 'react-facebook';
import YouTube from 'react-youtube';
import OurBackground from './img/ourbg.jpg';
import CoreValues from './img/core.jpg';
import HistoryData from "./data/history.json";
class AboutUs extends Component {
  state = {
    history:[]
  }
  componentWillMount(){
      this.setState({
        history:HistoryData,
      });

  }

  render() {
    const opts = {
      width:"1040",
      height:"584",
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 1
      }
    };
    var settings = {
          dots: false,
          infinite: false,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          focusOnSelect: true,
          initialSlide:1,
          arrows:true,
          autoplay: false,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 1340,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                initialSlide:1,
                infinite: false,
                dots: false
              }
            },
              {
                breakpoint: 1040,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  initialSlide:1,
                  infinite: false,
                  dots: false
                }
              },
              {
                breakpoint: 720,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  initialSlide:0,
                  infinite: false,
                  dots: false
                }
              },
            ]
        };

    return (
      <div className="Homepage">

        <Header page="aboutus"/>

          <div className="homeContentWhite">
            <a id="overview">
              <Container>
                <div className="AboutUsImage">

                  <Image className="AboutUsImage" src={OurBackground} />
                </div>
                <div className="AboutUsTitle">
                  Background of the Rotary Club of Central
                </div>
                <div className="AboutUsText left">
                The Rotary Club of Central (中區扶輪社) (RCC) is a registered society in Hong Kong, and is among the 30000+ clubs within Rotary International, the worldwide voluntary service network.
<br/><br/>
Officially chartered on 17 June 2009, our club was formed by 33 young professionals from various industries, spanning from banking and finance, information technology, healthcare and medical services, education and public relations to manufacturing, trading, airline logistics and telecommunication.  One-third of our members are alumni of the Rotary Foundation and ex-Rotaractors who have attended international or local educational exchange programs organized by Rotary.
<br/><br/>
Our club emphasizes hands-on participation in community services, with a vision to understand people from various backgrounds and see from their perspectives.  All our service projects are developed from vision to action by members.  One of our missions is to lend a helping hand to the underprivileged, such as newly immigrated children from mainland China.
<br/><br/>
RCC is part of District 3450 (district of Hong Kong, Macao, Mongolia & the People's Republic of China - Guangdong Province) within Rotary International (RI).  We as members believe and commit to the Rotary guiding principles, including the Four-Way Test (四大考驗):
<br/><br/>
Of the things we think, say or do:  我們所想、所講、所做：
<br/><br/>
<br/>
1.   Is it the TRUTH? 是否一切屬於真實?<br/>
2.   Is it FAIR to all concerned?   是否各方得到公平?<br/>
3.   Will it build GOODWILL and BETTER FRIENDSHIP?   能否促進信譽友誼?<br/>
4.   Will it be BENEFICIAL to all concerned? 能否兼顧彼此利益?<br/>
<br/>
                </div>
              </Container>
            </a>
          </div>

        <Footer/>
      </div>
    );
  }
}

export default AboutUs;
